import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import FilterTable from 'ntnu-react/material/FilterTable';
import RaisedButton from 'material-ui/RaisedButton';
import IconButton from 'material-ui/IconButton';
import OpenIcon from 'material-ui/svg-icons/action/open-in-new';

import {
    getProposalList,
    deleteProposal,
} from '../actions/proposalAction';

const defaultColumns = [
    { key: 'title', fieldName: 'Title', name: 'Tittel'},
    { key: 'author', fieldName: 'Author', name: 'Innsender'},
    { key: 'averagescore', fieldName: 'AverageScore', name: 'Prioritering'},
    { key: 'required', fieldName: 'Required1', name: 'Pålagt'},
    { key: 'created', fieldName: 'Created', name: 'Dato innmeldt'},
    { key: 'status', fieldName: 'Status1', name: 'Status'},
];

const underworkColumns = [
    { key: 'title', fieldName: 'Title', name: 'Tittel'},
    { key: 'portefolio', fieldName: 'Endringsportefolje', name: 'Endringsportefølje'},
    { key: 'adminarea', fieldName: 'AdminArea', name: 'Forvaltningsområde' },
    { key: 'contact', fieldName: 'ClientContact', name: 'Kontaktperson IT'},
    { key: 'follwup', fieldName: 'Responsible', name: 'Ansvarlig oppfølging' },
    { key: 'link', fieldName: 'Link', name: 'Prosjektrom' },
];

const completedColumns = [
    { key: 'title', fieldName: 'Title', name: 'Tittel'},
    { key: 'portefolio', fieldName: 'Endringsportefolje', name: 'Endringsportefølje'},
    { key: 'adminarea', fieldName: 'AdminArea', name: 'Forvaltningsområde' },
    { key: 'contact', fieldName: 'ClientContact', name: 'Kontaktperson IT'},
    { key: 'follwup', fieldName: 'Responsible', name: 'Ansvarlig oppfølging' },
    { key: 'link', fieldName: 'Link', name: 'Prosjektrom' },
];

class ProposalsPage extends React.Component {
    state = {
        selected: undefined,
        completeSelected: undefined,
        items: [],
        underwork: [],
        completed: [],
        columns: defaultColumns.map((col) => {
            return {...col};
        }),
        underworkColumns: underworkColumns.map((col) => {
            return {...col};
        }),
        completedColumns: completedColumns.map((col) => {
            return {...col};
        }),
    }

    componentDidMount() {
        this.props.dispatch(getProposalList());
    }

    componentWillReceiveProps(nextProps) {
        const proposals = nextProps.proposals.map((item) => {
            item = {...item};
            if (item.ProjectRoom && item.ProjectRoom) {
                item.Link = (<IconButton onClick={() => window.open(item.ProjectRoom, '_blank')}><OpenIcon/></IconButton>);
            }
            return item;
        });

        const items = [];
        const underwork = [];
        const completed = [];

        proposals.forEach((proposal) => {
            if (proposal.statusCode === '0' || proposal.statusCode === '1') {
                items.push(proposal);
            }
            else if (proposal.statusCode === '2') {
                underwork.push(proposal);
            }
            else if (proposal.statusCode === '3') {
                completed.push(proposal);
            }
        });

        this.setState({
            items,
            underwork,
            completed,
        });
    }

    handleNew = () => {
        this.props.router.push('/edit');
    }

    handleEdit = () => {
        this.props.router.push(`/edit/${this.state.selected.Id}`);
    }

    handleWorkEdit = () => {
        this.props.router.push(`/edit/${this.state.workSelected.Id}`);
    }

    handleDelete = () => {
        if (this.state.selected) {
            this.setState({selected: undefined});
            this.props.dispatch(deleteProposal(this.state.selected.Id));
        }
    }

    handleView = () => {
        this.props.router.push(`/view/${this.state.completeSelected.Id}`);
    }

    handleSelect = (selected) => {
        if (selected !== this.state.selected) {
            this.setState({selected});
        }
    }

    handleWorkSelect = (workSelected) => {
        if (workSelected !== this.state.workSelected) {
            this.setState({workSelected});
        }
    }

    handleCompleteSelect = (completeSelected) => {
        if (completeSelected !== this.state.completeSelected) {
            this.setState({completeSelected});
        }
    }

    render() {
        const { viewer } = this.props;
        const { selected, items, underwork, completed, workSelected, completeSelected } = this.state;

        const isOwner = selected && selected.CreatedBy === viewer.WorkEmail;

        const newButton = viewer.canAdd && (
            <RaisedButton
                label="Ny"
                primary={true}
                onClick={this.handleNew}
                style={{marginRight: '.5rem'}}
            />
        );

        const editButton = (
            <RaisedButton
                label={viewer.canAdd ? 'Rediger' : 'Se på'}
                onClick={this.handleEdit}
                disabled={!selected}
                style={{marginRight: '.5rem'}}
            />
        );

        const deleteButton = (
            <RaisedButton
                label="Slett"
                onClick={this.handleDelete}
                disabled={!isOwner}
            />
        );

        const workEditButton = (
            <RaisedButton
                label={viewer.canProcess ? 'Rediger' : 'Se på'}
                onClick={this.handleWorkEdit}
                disabled={!workSelected}
                style={{marginRight: '.5rem'}}
            />
        );

        return (
            <section>
                <p style={{
                    fontSize: '.9rem',
                    padding: '2em',
                    backgroundColor: '#f7f7f7',
                    clear: 'both',
                    maxWidth: 768,
                    marginTop: 12,
                }}>
                    Skjemaet har til hensikt å gi underlag til beslutningstakere om å iverksette endring og «Etablere prosjekt/forvaltningsoppdrag», - i dette som grunnlag for at prosjektet skal finansieres, prioriteres og få tilgang på ressurser.
                </p>

                <h2 style={{marginTop: '3rem'}}>Nye forslag</h2>
                <FilterTable
                    columns={this.state.columns}
                    items={items}
                    onSelect={this.handleSelect}
                    defaultSortBy={4}
                    defaultDesc={true}
                    height={items.length > 14 ? '500px' : 'inherit'}
                />
                <div style={{marginTop: '1rem'}}>
                    {newButton}
                    {editButton}
                    {deleteButton}
                </div>

                <h2 style={{marginTop: '3rem'}}>Under behandling</h2>
                <FilterTable
                    columns={this.state.underworkColumns}
                    items={underwork}
                    onSelect={this.handleWorkSelect}
                    defaultSortBy={0}
                    defaultDesc={true}
                    height={underwork.length > 14 ? '500px' : 'inherit'}
                />
                <div style={{marginTop: '1rem'}}>
                    {workEditButton}
                </div>

                <h2 style={{marginTop: '3rem'}}>Ferdig behandlet</h2>     
                <FilterTable
                    columns={this.state.completedColumns}
                    items={completed}
                    onSelect={this.handleCompleteSelect}
                    defaultSortBy={0}
                    defaultDesc={true}
                    height={completed.length > 14 ? '500px' : 'inherit'}
                />
                <div style={{marginTop: '1rem'}}>
                    <RaisedButton
                        label='Se på'
                        onClick={this.handleView}
                        disabled={!completeSelected}
                        style={{marginRight: '.5rem'}}
                    />
                </div>
            </section>
        );
    }
}

ProposalsPage.propTypes = {
    dispatch: PropTypes.func.isRequired,
    router: PropTypes.object.isRequired,
    proposals: PropTypes.array.isRequired,
    viewer: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
    return {
        proposals: state.proposalData.proposalList,
        viewer: state.viewer.viewer,
    };
}

export default connect(mapStateToProps)(ProposalsPage);



// WEBPACK FOOTER //
// ./src/containers/ProposalsPage.js